import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SiteService } from '@proxy/register-service/sites';
import { LocationDto } from '@proxy/register-service/locations';
import { LocationDefinition } from '@register/proxy/register-service/locations/location-type.enum';

@Component({
  selector: 'app-locations',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.scss'],
})
export class LocationsComponent implements OnInit {
  @Output() handleSelect = new EventEmitter<LocationDto>();

  @Input() isLoading = false;
  @Input() readonly = false;
  @Input() hideSelect = false;
  @Input() getAll = false;
  @Input() selectedLocation: LocationDto | null = null;
  @Input() checkStrictly: boolean = false;
  @Input() isAllSelected: boolean = false;
  @Input() checkable: boolean = false;
  @Input() checkedKeys: string[] = [];
  @Input() restrictedKeys: string[] = [];
  @Output() selectedLocationChange = new EventEmitter<LocationDto | null>();
  @Output() restrictedKeysChange = new EventEmitter<string[]>();
  @Output() checkedKeysChange = new EventEmitter<any[]>();
  siteId: string = '';
  locationDefinition = LocationDefinition;
  locationTypeKeys: {
    [key in LocationDefinition]: string[];
  } = {
    [LocationDefinition.HOME]: [],
    [LocationDefinition.SECONDARY]: [],
    [LocationDefinition.JOBSITE]: [],
  };

  constructor(public readonly siteService: SiteService) {}

  ngOnInit(): void {
    Object.keys(LocationDefinition).forEach(e => {
      this.locationTypeKeys[e as LocationDefinition] = this.restrictedKeys;
    });
  }

  onSiteIdChange(newSiteId: string) {
    this.siteId = newSiteId;
    this.selectedLocationChange.emit(null);
  }

  onCheckClick({ type, items }: { type: LocationDefinition; items: string[] }) {
    this.locationTypeKeys[type] = items;
    const newItems: string[] = Array.from(
      new Set(([] as string[]).concat(...(Object.values(this.locationTypeKeys) as string[][]))),
    );
    this.restrictedKeysChange.emit(newItems);
  }

  selectLocation(location: LocationDto) {
    this.handleSelect.emit(location);
  }
}
